<div class="gg-modal-overlay" (click)="onCancel()">
  <div class="gg-modal" (click)="$event.stopPropagation()">
    <header class="gg-head">
      <div class="gg-head-titleblock">
        <h2 class="gg-title" *ngIf="view === 'edit'">Manage gate groups</h2>
        <h2 class="gg-title" *ngIf="view === 'copy'">Copy gate groups to other performances</h2>
        <p class="gg-sub" *ngIf="view === 'edit'">Drag gates into a group to display them as a single column. Ungrouped gates remain individual.</p>
        <p class="gg-sub" *ngIf="view === 'copy'">Pick which groups to copy and which performances to copy them to. Groups with the same name on the target are replaced; other existing groups on the target stay intact.</p>
      </div>
      <button type="button" class="gg-close" (click)="onCancel()" aria-label="Close" [disabled]="saving || copyRunning">✕</button>
    </header>

    <div class="gg-body" *ngIf="view === 'edit'">
      <div class="gg-toolbar">
        <button type="button" class="gg-add-btn" [disabled]="saving" (click)="addGroup()">+ New group</button>
        <span class="gg-toolbar-meta">{{ groups.length }} group{{ groups.length === 1 ? '' : 's' }} · {{ gateNames.length }} gate{{ gateNames.length === 1 ? '' : 's' }} total</span>
      </div>

      <div class="gg-columns">
        <div class="gg-col gg-col-ungrouped">
          <header class="gg-col-head">
            <span class="gg-col-title">Ungrouped gates</span>
            <span class="gg-col-meta">{{ ungrouped.length }}</span>
          </header>
          <div class="gg-droplist"
               cdkDropList
               id="gg-ungrouped"
               [cdkDropListData]="ungrouped"
               [cdkDropListConnectedTo]="groupListIds()"
               (cdkDropListDropped)="onDrop($event)">
            <div class="gg-gate-chip"
                 *ngFor="let gate of ungrouped; trackBy: trackGate"
                 cdkDrag>
              <span class="gg-gate-handle" aria-hidden="true">⋮⋮</span>
              <span class="gg-gate-name">{{ gate }}</span>
            </div>
            <div class="gg-empty" *ngIf="!ungrouped.length">All gates are grouped</div>
          </div>
        </div>

        <div class="gg-groups-col">
          <div class="gg-col gg-col-group"
               *ngFor="let group of groups; trackBy: trackGroup">
            <header class="gg-col-head">
              <input type="text"
                     class="gg-group-name-input"
                     [class.input-error]="group.nameError"
                     placeholder="Group name (e.g. North Gates)"
                     [(ngModel)]="group.name"
                     [disabled]="saving" />
              <span class="gg-col-meta">{{ group.gateNames.length }}</span>
              <button type="button"
                      class="gg-group-delete"
                      appTooltip="Delete group (gates return to ungrouped)"
                      [disabled]="saving"
                      (click)="removeGroup(group)">✕</button>
            </header>
            <div class="gg-droplist"
                 cdkDropList
                 [id]="group.id"
                 [cdkDropListData]="group.gateNames"
                 [cdkDropListConnectedTo]="['gg-ungrouped'].concat(groupListIds())"
                 (cdkDropListDropped)="onDrop($event)">
              <div class="gg-gate-chip"
                   *ngFor="let gate of group.gateNames; trackBy: trackGate"
                   cdkDrag>
                <span class="gg-gate-handle" aria-hidden="true">⋮⋮</span>
                <span class="gg-gate-name">{{ gate }}</span>
              </div>
              <div class="gg-empty" *ngIf="!group.gateNames.length">Drag gates here</div>
            </div>
          </div>

          <button type="button"
                  class="gg-add-group-card"
                  *ngIf="!groups.length"
                  [disabled]="saving"
                  (click)="addGroup()">
            <span class="gg-add-icon">+</span>
            <span>Create your first group</span>
          </button>
        </div>
      </div>
    </div>

    <div class="gg-body gg-body-copy" *ngIf="view === 'copy'">
      <div class="gg-copy-section" *ngIf="copyableGroups().length">
        <header class="gg-copy-section-head">
          <span class="gg-copy-section-title">Groups to copy</span>
          <button type="button"
                  class="gg-copy-section-toggle"
                  [disabled]="copyRunning"
                  (click)="toggleAllGroupsForCopy()">
            {{ allGroupsSelectedForCopy ? 'Clear all' : 'Select all' }}
          </button>
        </header>
        <div class="gg-group-pick-list">
          <label class="gg-group-pick"
                 *ngFor="let group of copyableGroups(); trackBy: trackGroup"
                 [class.gg-group-pick--selected]="isGroupSelectedForCopy(group)">
            <input type="checkbox"
                   [checked]="isGroupSelectedForCopy(group)"
                   [disabled]="copyRunning"
                   (change)="toggleGroupForCopy(group)" />
            <div class="gg-group-pick-text">
              <div class="gg-group-pick-name">{{ group.name || 'Unnamed group' }}</div>
              <div class="gg-group-pick-meta">{{ group.gateNames.join(', ') }}</div>
            </div>
            <span class="gg-group-pick-count">{{ group.gateNames.length }}</span>
          </label>
        </div>
      </div>

      <div class="gg-copy-loading" *ngIf="copyLoading && !copyTargets.length">Loading performances…</div>

      <div class="gg-target-list" *ngIf="copyTargets.length">
        <div class="gg-target-head">
          <label class="gg-target-row gg-target-row--head">
            <input type="checkbox"
                   [checked]="allTargetsSelected"
                   [disabled]="copyRunning"
                   (change)="toggleAllTargets()" />
            <span class="gg-target-label">Performance</span>
            <span class="gg-target-meta">{{ selectedTargets.size }} of {{ copyTargets.length }} selected</span>
          </label>
        </div>
        <div class="gg-target-scroll">
          <label class="gg-target-row"
                 *ngFor="let t of copyTargets; trackBy: trackTarget"
                 [class.gg-target-row--selected]="isTargetSelected(t)"
                 [class.gg-target-row--done]="t.status === 'done'"
                 [class.gg-target-row--saving]="t.status === 'saving'"
                 [class.gg-target-row--error]="t.status === 'error'">
            <input type="checkbox"
                   [checked]="isTargetSelected(t)"
                   [disabled]="copyRunning"
                   (change)="toggleTarget(t)" />
            <div class="gg-target-text">
              <div class="gg-target-name">{{ t.description || 'Untitled performance' }}</div>
              <div class="gg-target-date">{{ t.date }}</div>
            </div>
            <span class="gg-target-chip gg-target-chip--warn" *ngIf="t.hasGroups && t.status !== 'done'">has groups · will merge</span>
            <span class="gg-target-chip gg-target-chip--saving" *ngIf="t.status === 'saving'">copying…</span>
            <span class="gg-target-chip gg-target-chip--done" *ngIf="t.status === 'done'">copied ✓</span>
            <span class="gg-target-chip gg-target-chip--error" *ngIf="t.status === 'error'" [appTooltip]="t.error || ''">failed</span>
          </label>
        </div>
      </div>

      <div class="gg-copy-empty" *ngIf="!copyLoading && !copyTargets.length">
        No other performances at this venue to copy to.
      </div>
    </div>

    <footer class="gg-foot">
      <p class="gg-error" *ngIf="error">{{ error }}</p>
      <p class="gg-error" *ngIf="copyError">{{ copyError }}</p>

      <div class="gg-foot-actions" *ngIf="view === 'edit'">
        <button type="button"
                class="gg-btn gg-btn-cancel"
                [disabled]="saving"
                (click)="onCancel()">Cancel</button>
        <button type="button"
                class="gg-btn gg-btn-secondary"
                *ngIf="hasGroupsToCopy"
                [disabled]="saving"
                appTooltip="Copy these groups to other performances at this venue"
                (click)="enterCopyView()">Copy to other performances…</button>
        <button type="button"
                class="gg-btn gg-btn-save"
                [disabled]="saving"
                (click)="onSave()">
          {{ saving ? 'Saving…' : 'Save groups' }}
        </button>
      </div>

      <div class="gg-foot-actions" *ngIf="view === 'copy'">
        <button type="button"
                class="gg-btn gg-btn-cancel"
                [disabled]="copyRunning"
                (click)="exitCopyView()">{{ copyDone ? 'Back' : 'Cancel' }}</button>
        <button type="button"
                class="gg-btn gg-btn-save"
                *ngIf="!copyDone"
                [disabled]="copyRunning || copyLoading || !selectedTargets.size || !selectedGroupIds.size"
                (click)="onCopyConfirm()">
          {{ copyRunning
              ? 'Copying…'
              : ('Copy ' + (selectedGroupIds.size || '0') + ' group' + (selectedGroupIds.size === 1 ? '' : 's')
                 + ' → ' + (selectedTargets.size || '0') + ' performance' + (selectedTargets.size === 1 ? '' : 's')) }}
        </button>
      </div>
    </footer>
  </div>
</div>
